import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { isObjectEmpty } from '@epicuro-next/utilities';
import { merge, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { ngbDateToUTC } from '../../utils';
import { DatePicker } from '../date-picker';
import { WeeksPresetData } from '../week-number/week-number.component';

@Component({
  selector: 'atx-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DatePickerComponent extends DatePicker implements OnDestroy {
  private destroy$ = new Subject<void>();
  public dateControl = new UntypedFormControl();

  public showWeekdays = true;

  @Input() public showWeekNumbers: boolean;
  @Input() public weeksPresetData: WeeksPresetData = {};

  @Output()
  public dateSelect = merge(
    this.dateControl.valueChanges.pipe(
      filter(Boolean),
      map((date) => ngbDateToUTC(date)),
    ),
    this.monthSelect$,
  ).pipe(takeUntil(this.destroy$));

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    super.ngOnDestroy();
  }

  public isObjectEmpty(object: object): boolean {
    // because Object.keys(new Date()).length === 0;
    // we have to do some additional check
    return isObjectEmpty(object);
  }
}
